import { FC } from 'react'
import { Virtuoso } from 'react-virtuoso'

import { Stack, Typography } from '@mui/material'
import { AutoCompleteOption } from '@/components/inputs/LicenseCompetitionsAutocomplete/LicenseCompetitionsAutocomplete'

import { CompetitionCheckboxItem } from './CompetitionCheckboxItem'
import { COMPETITIONS_LIST_HEIGHT } from './constants'

type SelectedCompetitionsListProps = {
  selectedCompetitionsList: AutoCompleteOption[]
  selectedCompetitionIds: string[]
  onCompetitionToggle: (competition: AutoCompleteOption) => void
}

export const SelectedCompetitionsList: FC<SelectedCompetitionsListProps> = ({
  selectedCompetitionsList,
  selectedCompetitionIds,
  onCompetitionToggle
}) => {
  if (!selectedCompetitionsList.length) {
    return (
      <Stack sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No selected competitions
        </Typography>
      </Stack>
    )
  }

  return (
    <Virtuoso
      data={selectedCompetitionsList}
      style={{
        height: COMPETITIONS_LIST_HEIGHT
      }}
      itemContent={(index, competition) => {
        const isSelected = selectedCompetitionIds.includes(competition.value)
        return (
          <CompetitionCheckboxItem
            key={competition.value}
            competition={competition}
            isSelected={isSelected}
            onToggle={onCompetitionToggle}
          />
        )
      }}
    />
  )
}
